import { render, staticRenderFns } from "./role_permission.vue?vue&type=template&id=653ecb1e&scoped=true&"
import script from "./role_permission.vue?vue&type=script&lang=js&"
export * from "./role_permission.vue?vue&type=script&lang=js&"
import style0 from "./role_permission.vue?vue&type=style&index=0&id=653ecb1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653ecb1e",
  null
  
)

export default component.exports